import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65292b69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ErrorPopin-content" }
const _hoisted_2 = { class: "ErrorPopin-subtitle text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ErrorPopin-img" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/error/error.png 1x, /dev/error/error@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/error/error.png",
      alt: "error"
    })
  ])
], -1))
const _hoisted_4 = { class: "ErrorPopin-title h1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref: "popin",
      class: _normalizeClass([{ 'is-active': _ctx.active, 'is-in': _ctx.isIn }, "ErrorPopin padded grid"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('error-page.title')), 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('error-page.description')), 1),
        _createVNode(_component_ButtonHover, {
          onClick: _ctx.onReload,
          class: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('error-page.cta')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 2)
  ]))
}